import React from 'react';
import { getSectionDivider } from '../../utils/SectionDividerUtil';
import styles from './SectionDivider.scss';
import { observer } from 'mobx-react-lite';

interface SectionDividerProps {
    itemId: string;
    prevItemId?: string;
}

const SectionDivider = ({ itemId, prevItemId }: SectionDividerProps) => {
    const [shouldShowDivider, sectionDividerText] = getSectionDivider(itemId, prevItemId);

    return shouldShowDivider ? (
        <div className={styles.divider} role="heading">
            {sectionDividerText}
        </div>
    ) : null;
};

export default observer(SectionDivider);
